import React, { useEffect, useRef, useContext } from 'react'
import { useSelector } from 'react-redux'
import PageContext from '@contexts/pageContext'

import { useOutsideClick, useSetState } from '@campaignhub/react-hooks'
import { Box, FormField, Text } from '@campaignhub/suit-theme'

import custom from '@styles/custom.module.scss'

const defaultState = {
  showFilter: false,
}

const ServiceFilter = () => {
  const [state, setState] = useSetState(defaultState)
  const { showFilter } = state

  const { result: serviceTypesV3 } = useSelector(reduxState => reduxState.serviceTypesV3)
  const { callbacks: { toggleSelectedService }, selectedService } = useContext(PageContext)

  const contentEl = useRef()
  const [isClickedOutside, setIsClickedOutside] = useOutsideClick(contentEl, { enabled: showFilter })

  useEffect(() => {
    if (isClickedOutside && showFilter){
      setState({ showFilter: !showFilter })
      setIsClickedOutside(false)
    }
  }, [isClickedOutside])

  return (
    <FormField direction="column" boxProps={{ paddingBottom: 'medium' }}>
      <Box className={custom.root} ref={contentEl}>
        <select
          onMouseDown={(e) => {
            e.preventDefault()
            setState({ showFilter: !showFilter })
          }}
          value="Services"
        >
          <option>Services</option>
        </select>

        {showFilter && (
          <Box className={custom.popup}>
            <Box flexDirection="column" maxHeight="280px" overflowY="auto">
              {Object.values(serviceTypesV3).map(service => (
                <Box flexDirection="row" paddingTop="small" paddingBottom="medium" alignItems="center">
                  <input
                    className={custom.checkbox}
                    onChange={e => toggleSelectedService(e.target.checked, service.value)}
                    type="checkbox"
                    checked={selectedService.includes(service.value)}
                  />
                  <Text fontSize="small" marginLeft="medium">{service.name}</Text>
                </Box>
              ))}
            </Box>
          </Box>
        )}
      </Box>
    </FormField>
  )
}

export default ServiceFilter
